import { useQuery } from '@tanstack/react-query';

import { getCategories } from '@/modules/categories/domain/resources/core/getCategories';

export const useCategories = () => {
  const { data: categories, isLoading } = useQuery(['categories'], getCategories, {
    staleTime: Infinity,
  });

  return { categories, isLoading };
};
